"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleImage = consoleImage;
exports.createPoster = createPoster;
const tslib_1 = require("tslib");
const html2canvas_1 = tslib_1.__importDefault(require("html2canvas"));
const utils_1 = require("../utils");
require("./index.less");
/** hideStr 脱敏保留位数 */
const UID_MASK_VISIBLE_LEN = 3;
/** toDataURL 压缩质量（部分环境对 PNG 仍生效） */
const POSTER_PNG_QUALITY = 0.7;
/**
 * 校验海报昵称颜色，避免异常字符串注入 HTML
 */
function sanitizeNickColor(input) {
    if (!input || typeof input !== 'string') {
        return '#ffffff';
    }
    const s = input.trim();
    if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(s)) {
        return s;
    }
    if (/^rgba?\(\s*[\d.]+\s*(,\s*[\d.]+\s*){2}(,\s*[\d.]+\s*)?\)$/.test(s)) {
        return s;
    }
    return '#ffffff';
}
function consoleImage(url) {
    if (process.env.NODE_ENV === 'development') {
        console.log(`%c sup?`, `
          font-size: 1px;
          padding: 200px;
          background-image: url(${url});
          background-repeat: no-repeat;
          background-size: contain;
          color: transparent;
        `);
    }
}
/**
 * 创建海报
 */
async function createPoster({ qrCode, uid, nick, avatar, poster, nickColor }) {
    const nickString = `${nick} (${(0, utils_1.hideStr)((uid || '').toString(), UID_MASK_VISIBLE_LEN)})`;
    const nickColorResolved = sanitizeNickColor(nickColor);
    const html = `
        <div class="box">
            <div class="avatar-box">
                <img src="${avatar}" class="avatar">
                <div class="nick" style="color: ${nickColorResolved}">${nickString}</div>
            </div>
            <img src="${qrCode}" class="qr-code">
            <img src="${poster}" class="poster">
        </div>
    `;
    const box = document.createElement('div');
    box.id = 'poster-1kqtfgukiy';
    box.innerHTML = html;
    document.body.appendChild(box);
    console.log('海报元素已添加到页面22');
    await new Promise((res) => {
        setTimeout(() => {
            console.log('海报元素已添加到页面32');
            res(true);
        });
    });
    try {
        console.log('开始生成海报');
        const canvas = await (0, html2canvas_1.default)(box.querySelector('.box'), {
            useCORS: true,
            backgroundColor: null,
            logging: false
        });
        console.log('海报生成完成');
        //关闭抗锯齿
        const context = canvas.getContext('2d');
        if (!context) {
            throw new Error('无法获取canvas上下文');
        }
        console.log('生成海报前1');
        const ctx = context;
        ctx.mozImageSmoothingEnabled = false;
        ctx.webkitImageSmoothingEnabled = false;
        ctx.msImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
        console.log('生成海报前2');
        const pic = await canvas.toDataURL('image/png', POSTER_PNG_QUALITY);
        console.log('生成海报后');
        console.log(pic);
        return pic;
    }
    catch (e) {
        console.error('生成海报失败', e);
        console.error(e);
        throw new Error('生成海报失败，请稍后再试');
    }
    finally {
        // 移除海报元素
        box.remove();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQXlCQSxvQ0FjQztBQUtELG9DQTJFQzs7QUF2SEQsc0VBQXNDO0FBQ3RDLG9DQUFtQztBQUNuQyx3QkFBc0I7QUFFdEIscUJBQXFCO0FBQ3JCLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxDQUFDO0FBQy9CLG9DQUFvQztBQUNwQyxNQUFNLGtCQUFrQixHQUFHLEdBQUcsQ0FBQztBQUUvQjs7R0FFRztBQUNILFNBQVMsaUJBQWlCLENBQUMsS0FBeUI7SUFDaEQsSUFBSSxDQUFDLEtBQUssSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUN0QyxPQUFPLFNBQVMsQ0FBQztJQUNyQixDQUFDO0lBQ0QsTUFBTSxDQUFDLEdBQUcsS0FBSyxDQUFDLElBQUksRUFBRSxDQUFDO0lBQ3ZCLElBQUksb0NBQW9DLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUM7UUFDL0MsT0FBTyxDQUFDLENBQUM7SUFDYixDQUFDO0lBQ0QsSUFBSSwyREFBMkQsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQztRQUN0RSxPQUFPLENBQUMsQ0FBQztJQUNiLENBQUM7SUFDRCxPQUFPLFNBQVMsQ0FBQztBQUNyQixDQUFDO0FBQ0QsU0FBZ0IsWUFBWSxDQUFDLEdBQVc7SUFDcEMsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsS0FBSyxhQUFhLEVBQUUsQ0FBQztRQUN6QyxPQUFPLENBQUMsR0FBRyxDQUNQLFNBQVMsRUFDVDs7O2tDQUdzQixHQUFHOzs7O1NBSTVCLENBQ0EsQ0FBQztJQUNOLENBQUM7QUFDTCxDQUFDO0FBRUQ7O0dBRUc7QUFDSSxLQUFLLFVBQVUsWUFBWSxDQUFDLEVBQy9CLE1BQU0sRUFDTixHQUFHLEVBQ0gsSUFBSSxFQUNKLE1BQU0sRUFDTixNQUFNLEVBQ04sU0FBUyxFQVNaO0lBQ0csTUFBTSxVQUFVLEdBQUcsR0FBRyxJQUFJLEtBQUssSUFBQSxlQUFPLEVBQUMsQ0FBQyxHQUFHLElBQUksRUFBRSxDQUFDLENBQUMsUUFBUSxFQUFFLEVBQUUsb0JBQW9CLENBQUMsR0FBRyxDQUFDO0lBQ3hGLE1BQU0saUJBQWlCLEdBQUcsaUJBQWlCLENBQUMsU0FBUyxDQUFDLENBQUM7SUFDdkQsTUFBTSxJQUFJLEdBQUc7Ozs0QkFHVyxNQUFNO2tEQUNnQixpQkFBaUIsS0FBSyxVQUFVOzt3QkFFMUQsTUFBTTt3QkFDTixNQUFNOztLQUV6QixDQUFDO0lBQ0YsTUFBTSxHQUFHLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUMxQyxHQUFHLENBQUMsRUFBRSxHQUFHLG1CQUFtQixDQUFDO0lBQzdCLEdBQUcsQ0FBQyxTQUFTLEdBQUcsSUFBSSxDQUFDO0lBQ3JCLFFBQVEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQy9CLE9BQU8sQ0FBQyxHQUFHLENBQUMsY0FBYyxDQUFDLENBQUM7SUFDNUIsTUFBTSxJQUFJLE9BQU8sQ0FBQyxDQUFDLEdBQUcsRUFBRSxFQUFFO1FBQ3RCLFVBQVUsQ0FBQyxHQUFHLEVBQUU7WUFDWixPQUFPLENBQUMsR0FBRyxDQUFDLGNBQWMsQ0FBQyxDQUFDO1lBQzVCLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUNkLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQyxDQUFDLENBQUM7SUFDSCxJQUFJLENBQUM7UUFDRCxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQ3RCLE1BQU0sTUFBTSxHQUFHLE1BQU0sSUFBQSxxQkFBVyxFQUFDLEdBQUcsQ0FBQyxhQUFhLENBQUMsTUFBTSxDQUFnQixFQUFFO1lBQ3ZFLE9BQU8sRUFBRSxJQUFJO1lBQ2IsZUFBZSxFQUFFLElBQUk7WUFDckIsT0FBTyxFQUFFLEtBQUs7U0FDakIsQ0FBQyxDQUFDO1FBQ0gsT0FBTyxDQUFDLEdBQUcsQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUN0QixPQUFPO1FBQ1AsTUFBTSxPQUFPLEdBQUcsTUFBTSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUN4QyxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUM7WUFDWCxNQUFNLElBQUksS0FBSyxDQUFDLGVBQWUsQ0FBQyxDQUFDO1FBQ3JDLENBQUM7UUFDRCxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQ3RCLE1BQU0sR0FBRyxHQUFHLE9BSVgsQ0FBQztRQUNGLEdBQUcsQ0FBQyx3QkFBd0IsR0FBRyxLQUFLLENBQUM7UUFDckMsR0FBRyxDQUFDLDJCQUEyQixHQUFHLEtBQUssQ0FBQztRQUN4QyxHQUFHLENBQUMsdUJBQXVCLEdBQUcsS0FBSyxDQUFDO1FBQ3BDLEdBQUcsQ0FBQyxxQkFBcUIsR0FBRyxLQUFLLENBQUM7UUFDbEMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUN0QixNQUFNLEdBQUcsR0FBRyxNQUFNLE1BQU0sQ0FBQyxTQUFTLENBQUMsV0FBVyxFQUFFLGtCQUFrQixDQUFDLENBQUM7UUFDcEUsT0FBTyxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUNyQixPQUFPLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ2pCLE9BQU8sR0FBRyxDQUFDO0lBQ2YsQ0FBQztJQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7UUFDVCxPQUFPLENBQUMsS0FBSyxDQUFDLFFBQVEsRUFBRSxDQUFDLENBQUMsQ0FBQztRQUMzQixPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQ2pCLE1BQU0sSUFBSSxLQUFLLENBQUMsY0FBYyxDQUFDLENBQUM7SUFDcEMsQ0FBQztZQUFTLENBQUM7UUFDUCxTQUFTO1FBQ1QsR0FBRyxDQUFDLE1BQU0sRUFBRSxDQUFDO0lBQ2pCLENBQUM7QUFDTCxDQUFDIn0=